// extracted by mini-css-extract-plugin
export var Subnavigation = "Subnavigation-module--Subnavigation--589bf";
export var Subnavigation_back = "Subnavigation-module--Subnavigation_back--69d04";
export var isAncestor = "Subnavigation-module--isAncestor--51dfc";
export var isCurrent = "Subnavigation-module--isCurrent--bb7b4";